export const JWT_KEY = 'jwtToken';
export const JWT_EXPIRES_KEY = 'jwtExpiresAt';
export const MODULES_KEY = 'modulos';

const SESSION_KEYS = [JWT_KEY, JWT_EXPIRES_KEY, MODULES_KEY];

function getSessionStorage() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }
  return window.sessionStorage;
}

function getLocalStorage() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  return window.localStorage;
}

function readItem(key) {
  const session = getSessionStorage();
  const local = getLocalStorage();
  const fromLocal = local?.getItem(key);

  if (fromLocal !== null && fromLocal !== '') {
    if (session?.getItem(key) !== fromLocal) {
      session?.setItem(key, fromLocal);
    }
    return fromLocal;
  }

  session?.removeItem(key);
  return null;
}

function writeItem(key, value) {
  getSessionStorage()?.setItem(key, value);
  getLocalStorage()?.setItem(key, value);
}

function removeItem(key) {
  getSessionStorage()?.removeItem(key);
  getLocalStorage()?.removeItem(key);
}

export function getSessionItem(key) {
  return readItem(key);
}

export function setSessionItem(key, value) {
  writeItem(key, value);
}

export function removeSessionItem(key) {
  removeItem(key);
}

export function clearTabSessionItemsOnly() {
  SESSION_KEYS.forEach((key) => {
    getSessionStorage()?.removeItem(key);
  });
}

export function clearPersistedSession() {
  SESSION_KEYS.forEach(removeItem);
}

export function hydrateTabSessionFromSharedStorage() {
  SESSION_KEYS.forEach((key) => {
    readItem(key);
  });
}

export function getSessionModules() {
  try {
    const raw = getSessionItem(MODULES_KEY);
    if (!raw) {
      return [];
    }
    const modules = JSON.parse(raw);
    return Array.isArray(modules) ? modules : [];
  } catch {
    return [];
  }
}
